// extracted by mini-css-extract-plugin
module.exports = {"modal_title":"styles_modal_title__KNcuG","modal_desc":"styles_modal_desc__3sQmN","button__disagree":"styles_button__disagree__GOaBy","button__agree":"styles_button__agree__ixK2E"};